module.exports = __webpack_public_path__ + "media/components/spaces/answer-question-sidebar-panel-1-21c94f17850ebf719b58126f62525af5.png";